import Markdown from "markdown-to-jsx"

import { cn } from "@/client/lib/utils"

interface MarkdownRendererProps {
  children: string
  className?: string
}

const MarkdownRenderer = ({ children, className }: MarkdownRendererProps) => {
  return (
    <div
      className={cn(
        "prose prose-sm dark:prose-invert max-w-none",
        "prose-headings:font-semibold prose-headings:tracking-tight",
        "prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg",
        "prose-p:leading-7 prose-p:my-4",
        "prose-a:text-primary prose-a:underline hover:prose-a:text-primary/80",
        "prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-sm",
        "prose-pre:bg-muted prose-pre:p-4 prose-pre:rounded-lg",
        "prose-ul:my-4 prose-ul:list-disc prose-ul:pl-6",
        "prose-ol:my-4 prose-ol:list-decimal prose-ol:pl-6",
        "prose-li:my-1",
        "prose-blockquote:border-l-4 prose-blockquote:border-muted-foreground/30 prose-blockquote:pl-4 prose-blockquote:italic",
        className
      )}
    >
      <Markdown>{children}</Markdown>
    </div>
  )
}

export { MarkdownRenderer as Markdown }
